import { LiveEventsTypes } from '@setplex/tria-api'

export const FORMAT_LIVE_EVENTS_TYPES = {
  [LiveEventsTypes.LIVE]: 'Live',
  [LiveEventsTypes.UPCOMING]: 'Upcoming',
  [LiveEventsTypes.PAST]: 'Past',
}
